module.exports = __webpack_public_path__ + "/static/assets/d92e74438d72c2223692825df66e026e.svg";